export default __webpack_public_path__ + "static/newton-9b08d318bd9666b616646e57936fb546.jpg";